
var eventManagement = {
   
    removeSpecFromCountry : function($id,$country_id){

        if (confirm('Are you sure you want to remove this spec?')) {
           if($id != null){
                $.ajax({                    
                    type : "POST",               
                    url  : "/api/specs/remove-country-spec",
                    data: { 
                        id     : $id,
                        country_id     :$country_id
                    },
                    success:function(data){
                       load_partial($('[data-partial="events.views.specs-management"]'));
                       actionResponseModal( data.success || 'success', 'success');
                    },
                    error:function(data){
                        actionResponseModal( data.responseJSON.message || 'error', 'error');
                    }

                });
            }

        } 

         
    },
    deleteEvent : function($id){

        if (confirm('Are you sure you want to remove this event?')) {
           if($id != null){
                $.ajax({                    
                    type : "DELETE",               
                    url  : "/api/events/"+ $id,
                    success:function(data){
                       load_partial($('[data-partial="events.views.events-management"]'));
                       actionResponseModal( data.success || 'success', 'success');
                    },
                    error:function(data){
                        actionResponseModal( data.responseJSON.message || 'error', 'error');
                    }

                });
            }

        } 

         
    },

     deleteUser : function($id){

        if (confirm('Are you sure you want to remove this user?')) {
           if($id != null){
                $.ajax({                    
                    type : "POST",               
                    url  : "/api/users/delete-user",
                     data: { 
                        id     : $id
                    },
                    success:function(data){
                       load_partial($('[data-partial="events.views.users-management"]'));
                       actionResponseModal( data.success || 'success', 'success');
                    },
                    error:function(data){
                        actionResponseModal( data.responseJSON.message || 'error', 'error');
                    }

                });
            }

        } 

         
    },
      import_users: function( data ) {
    
        $( "#import-dialog" ).on( 'shown.bs.modal', function( ) {
            $( "#import-dialog .modal-footer" ).hide( );
          
            $( "#import-dialog .btn-ok" ).on( 'click', function( ) {

                var $files = [ ],
                    $vanity = {},
                    $types = [ ];


                $( '#import-dialog input[name="f"]' ).each( function( ) {
                    var v = $( this ).val( );
                    $files.push( v );
                } );

                $( '#import-dialog select' ).each( function( ) {
                    var v = $( this ).val( );
                    $vanity[ $( this ).attr( 'name' ) ] = $( this ).val( );
                } );

                $( "#import-dialog" ).modal( 'hide' );

                
                  $('body').append(`<div id="waiting-response" style="background: rgba(255,255,255,.5)!important;top: 0; left: 0;bottom: 0;z-index: 9999;position: fixed;right: 0;">
                        <div style="position: absolute;left: 50%;top: 50%; margin: -20px 0 0 -20px;width: 40px;height: 40px;">
                        <div class="spinner-chase">
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                          <div class="chase-dot"></div>
                      </div>
                      </div>
                  </div>`);

                $.ajax( {
                    url: '/api/users/import',
                    data: {
                        files: $files,
                        vanity: $vanity
                    },
                    type: 'PUT',
                    error: function( ) {
                         $('#waiting-response').remove();
                          actionResponseModal( 'Something went wrong', 'error');
                    },
                    success: function( data ) {
                        $('#waiting-response').remove();
                        setTimeout(function(){
                             location.reload();
                         },3000);
                       
                        actionResponseModal( 'Successfuly submited. Import information is not available', 'success');

                    }
                } );


            } );

            initForm( '#import-dialog' );
            
        } ).on( 'hidden.bs.modal', function( ) {
            $( "#import-dialog" ).remove( );
            location.reload();
        } ).modal( 'show' );

    },
     userUploader:function(target){
        
        if( $('#'+target).hasClass('singleUploaderInitiated') ){
            return false;
        }
        $('#'+target).addClass('singleUploaderInitiated');

        var uploader = new plupload.Uploader({
            runtimes        : 'html5',
            browse_button   : target + '-pickfiles',
            container       : target + '-container',
            drop_element    : target + '-dropzone',
            url             : '/upload',
            headers:{
                'X-CSRF-TOKEN':$('meta[name="csrf-token"]').attr('content')
            },          
            filters : {
                max_file_size : '8000mb',
                mime_types: $('#'+target).data('mime_types') || [
                    {title : "Documents",   extensions : "pdf,csv,tsv,xml,doc,docx,xls,xlsx,ppt,pptx,webp"},
                    {title : "Video files", extensions : "mp4,mov"},
                    {title : "Image files", extensions : "jpg,jpeg,gif,png,ico,svg"},
                    {title : "Zip files",   extensions : "zip"},
                    {title : "Audio files",   extensions : "mp3,wav"}
                ]
            }
        });

        uploader.bind('Init', function(up, params) {});

        $('#'+target + '-uploadfiles').click(function(e) {
            uploader.start();
            e.preventDefault();
        });
        uploader.init();

        
        uploader.bind('FilesAdded', function(up, files) {

            $.each(files, function(i, file) {
                var markup = '   <div id="' + file.id + '"><p>'+file.name+ '</p>\
                                <div class="progress progress-small" style="display:none;height:6px;">\
                                    <div class="progress-bar" style="width: 0%;"></div>\
                                </div>';
                $('#'+target + '-uploaded-files').html(markup);
            });
            up.refresh();

            uploader.start();
        });

        uploader.bind('UploadProgress', function(up, file) {
            $('#' + file.id + " .progress").fadeIn('fast');
            $('#' + file.id + " .progress .progress-bar").width(file.percent + "%");
        });

        uploader.bind('Error', function(up, err) {
            $('#'+target + '-filelist').append("<div>Error: " + err.code +
                ", Message: " + err.message +
                (err.file ? ", File: " + err.file.name : "") +
                "</div>"
            );

            up.refresh(); 
        });

        uploader.bind('FileUploaded', function(up, file,ee) {

             var width   = $('#' + target + '-container  .details img').attr('data-width'),
                height  = $('#' + target + '-container  .details img').attr('data-height'),
                container = $('#' + target + '-container');
            var server_response = JSON.parse(ee.response);
            var ext = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase();
            var uniqueKey = "uploads/" + file.type.replace('/','_') +'/'+file.id + "." + ext;
            
            container.find('.details').show();
            container.find('.details').html('<img width="150" height="150" data-width="'+width+'" data-height="'+height+'" src="/'+server_response.path+'" data-src="'+server_response.path+'" class="img-fluid" />');
            container.find('.progress').fadeOut('fast');

            container.find('.uploader_original_filename' ).val(file.name);
            
           
            container.find('.uploader_filename' ).val(server_response.path);

            container.find('.file_id').val(0);
            container.find('.crop-data').val('[]');
 
            $('#' + target + ' .cropper-trigger').show();
            $('#' + target + ' .cropper-trigger').data('src', '/tmp'+file.id+ "." + ext);
            $('#' + target + ' .remove-file-trigger').show();
            $('#' + target + ' .remove-assigned-file').show();
            
            if($("#import-dialog:visible").length > 0){
                
                $('#import-dialog:visible .modal-body').load('/api/users/import-preview?import_file='+server_response.path, function(){
                    $("#import-dialog .modal-footer").show();    
                    initForm('#import-dialog .modal-body');

                });
            }



        });

    },
    addUploadingSpace:function(){
        var $row_index = Number($('.uploading-spaces-wrapper .uploading-space-item').length + 1);
        $('.uploading-spaces-wrapper').append('<div class="uploading-space-item position-relative" data-row_index="'+ $row_index +'" data-partial="events.forms.new-uploading-space"></div');
        load_partial($('.uploading-spaces-wrapper [data-partial="events.forms.new-uploading-space"]'));
    },
    reIndexSpaces:function(){
         $( '.uploading-spaces-wrapper .uploading-space-item' ).each( function( $index ) {
           $(this).find('.row-index').text($index +1);
           if( $index==0){
                 $(this).find('.btn-delete-row').hide();
           }else{
             $(this).find('.btn-delete-row').show();
           }
        } );
    }

};
 